// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1__f100b9d3391fb3d9187f","cls2":"AccountMenuButton-cls2__cdff8de77edfd493cf26 AccountMenuButton-cls1__f100b9d3391fb3d9187f"};